import angular from 'angular';
import '../../services/tags-groups';
import '../../services/errors';
import { get, clone, isEmpty } from 'lodash';

const module = angular.module('whyline.modals.tags-groups', [
	'whyline.services.errors',
]);

const TagsGroupsModalController = function(
	$uibModalInstance,
	$translate,
	$timeout,
	dialog,
	NotificationService,
	TagsGroupsService,
	ErrorService,
	tagGroupId,
) {
	'ngInject';

	this.tagGroup = {
		name: '',
		order: 1,
		tags: [],
	};

	this.currentTag = '';
	this.arrayTags = [];
	this.initialTags = [];

	this.oderPattern = /^([0-9]|10)$/;

	const init = () => {
		const tagGroupPromise = tagGroupId ? TagsGroupsService.GetOneAsPromiseFromServer(tagGroupId) : Promise.resolve(this.tagGroup);

		return Promise.resolve(tagGroupPromise).then((tagGroup) => {
			$timeout(() => {
				let currentTagGroup = {
					name: tagGroup.name,
					order: tagGroup.order,
				};

				currentTagGroup.tags = tagGroup.tags.map(tag => {
					return {
						tagName: tag.tagName,
						placeIds: tag.placeIds,
					};
				});

				this.tagGroup = TagsGroupsService.Copy(currentTagGroup);

				this.arrayTags = tagGroup.tags.map(tag => tag.tagName.toLowerCase());

				this.initialTags = clone(this.arrayTags).filter(tag => !isEmpty(tag));
			});
		}).catch(ErrorService.handler);
	};

	this.inputTag = event => {
		if (
			(event.which === 188 && !this.checkLessThanCharacter()) ||
			(event.which === 13 && this.currentTag !== ' ')
		) {
			let tag = this.currentTag.indexOf(',') !== -1 ? this.currentTag.substring(0, this.currentTag.indexOf(',')) : this.currentTag;

			if (!isEmpty(tag)) {
				if (this.arrayTags.indexOf(tag.toLowerCase()) === -1) {
					this.tagGroup.tags.push({
						tagName: tag
					});
					this.arrayTags.push(tag.toLowerCase());
				}
			}

			this.currentTag = '';
		}
	};

	this.removeTag = tagName => {
		if (this.initialTags.indexOf(tagName.toLowerCase()) !== -1) {
			dialog
				.confirm($translate.instant('tag-group.remove-tag'))
				.then(() => this.deleteTag(tagName))
				.catch(() => 'canceled');
		} else {
			this.deleteTag(tagName);
		}
	};

	this.deleteTag = tagName => {
		this.tagGroup.tags = this.tagGroup.tags.filter(tag => tag.tagName !== tagName);
		this.arrayTags = this.arrayTags.filter(tag => tag !== tagName.toLowerCase());
		this.initialTags = this.initialTags.filter(tag => tag !== tagName.toLowerCase());
	};

	this.cancel = () => {
		$uibModalInstance.close('cancel');
	};

	this.checkLessThanCharacter = () => {
		return /^(<)\1*$/.test(this.currentTag) || this.currentTag.endsWith('<');
	};

	this.minMaxAllowed = () => {
		const orderInt = parseInt(this.tagGroup.order);

		if (!isNaN(orderInt)) {
			if (orderInt > 10000) {
				this.tagGroup.order = 10000;
			} else if (orderInt < 1) {
				this.tagGroup.order = 1;
			}
		}
	}

	let validate = () => {
		const name = this.tagGroup.name;
		const orderStr = this.tagGroup.order;
		const orderInt = parseInt(orderStr);
		const tags = this.tagGroup.tags;

		if (!name) {
			NotificationService.Warning($translate.instant('mandatory_tag_group_name'));
			return false;
		}

		if (name.length > 25) {
			NotificationService.Warning($translate.instant('tag_group_name_length'));
			return false;
		}

		if ((!orderStr && orderStr != 0) || (isNaN(orderStr) && !orderStr.length)) {
			NotificationService.Warning($translate.instant('mandatory_tag_group_order'));
			return false;
		}

		if (isNaN(orderInt) || orderInt < 1 || orderInt > 10000) {
			NotificationService.Warning($translate.instant('tag_group_order_range'));
			return false;
		}

		if (!tags.length) {
			NotificationService.Warning($translate.instant('mandatory_tag_group_tags'));
			return false;
		}

		return true;
	};

	this.save = () => {
		if (validate()) {
			const name = this.tagGroup.name;

			let promise = null;
			let message = '';

			this.tagGroup.tags = this.tagGroup.tags.map(tag => {
				if (!tag.placeIds) {
					tag.placeIds = [];
				}

				return tag;
			});

			if (tagGroupId) {
				promise = TagsGroupsService.Update(this.tagGroup, tagGroupId);
				message = $translate.instant('tag_group_{name}_updated_succ').replace('{name}', name);
			} else {
				promise = TagsGroupsService.Create(this.tagGroup);
				message = $translate.instant('tag_group_{name}_created_succ').replace('{name}', name);
			}

			promise
				.then(() => {
					NotificationService.Success(message);
					$uibModalInstance.close('success');
				})
				.catch((error) => {
					const errorData = get(error, 'data', undefined);

					if (errorData && errorData.statusCode === 406) {
						const message = $translate.instant(errorData.reason);

						NotificationService.Warning(message);
					} else {
						ErrorService.handler(error);
					}
				});
		}
	};

	init();
}

module.exports = module.controller('TagsGroupsModalController', TagsGroupsModalController);
